import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useHeatMap({ selectedDate, isLastRecordPending }) {
  const { getHeatMapByDate } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["heatmap", selectedDate],
    queryFn: async () => {
      if (!selectedDate) return null;
      const response = await getHeatMapByDate({ date: selectedDate });
      if (!response?.data) return null;
      return `data:image/jpeg;base64,${response.data}`;
    },
    enabled:
      !isLastRecordPending &&
      selectedDate !== null &&
      selectedDate !== "" &&
      selectedDate !== undefined &&
      selectedDate !== "Invalid Date",
  });

  return { data, isLoading };
}
